import { filter } from 'rxjs/operators';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { ComponentMessageDispatcher } from '../../../core/service/component-message-dispather.service';
import { MessageService } from '../../../core/service/message.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { MailService } from '../../service/data/mail.service';
import { LetterFormComponentBase } from '../base/letter-form.base';
import { ActivatedRoute } from '@angular/router';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';

@Component({
    selector: 'app-send-lease-agreement-letter',
    templateUrl: './send-tenant-mails-form.component.html',
    styleUrls: ['./send-tenant-mails-form.component.scss'],
    providers: [NavigationService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SendTenantMailsFormComponent extends LetterFormComponentBase {
  constructor(
    private _messageDispather: ComponentMessageDispatcher,
    private _nativeWindow: NativeWindowService,
    activatedRoute: ActivatedRoute,
    dispatcher: CommandDispatcher,
    fb: FormBuilder,
    fc: FormControlExFactory,
    handlerResolver: CommandHandlerResolver,
    service: MailService,
    messageService: MessageService,
    navigation: NavigationService
  ) {
    super(activatedRoute, fb, fc, service, dispatcher, handlerResolver, messageService, navigation);
    this.AddSubscription(
      this._messageDispather.messages.pipe(filter(message => message.tenants)).subscribe(message => {
        _messageDispather.messageDelivered();
        this.recipients = message.tenants.slice();
        this.showRecipients = this.recipients.length > 0;
      })
    );
    this.restoreRecipients();
  }

  recipients: any[];
  showRecipients: boolean = false;
  showPreview = false;

  get hasRecipients(): boolean {
    return Array.isArray(this.recipients) && this.recipients.length > 0;
  }

  get isSaveDisabled(): boolean {
    return !this.form || this.form.invalid || this.form.pristine || this.form.disabled || !this.hasRecipients;
  }

  get isPreviewDisabled(): boolean {
    return !this.form || this.form.invalid || this.form.disabled || !this.hasRecipients;
  }

  get isSendDisabled(): boolean {
    return !this.form || this.form.invalid || this.form.disabled || !this.hasRecipients;
  }

  private _getFormData() {
    let data = this.form.value;
    data.leaseAgreements = (this.recipients ?? []).map(recipient => recipient.id);
    return data;
  }

  private clearRecipients() {
    this.recipients = [];
    this.showRecipients = false;
  }

  private restoreRecipients() {
    if (!this.hasRecipients) this.handleMissingRecipients();
  }

  private handleMissingRecipients() {
    this.clearRecipients();
    this.messageService.showError('COMMON.RECIPIENTS_REQUIRED');
    this.navigation.navigate(['mail', 'recipients']);
  }

  cancel() {
    this.clearRecipients();
    this.navigation.navigateBack();
  }

  onSubmit(): void {
    if (this.form.invalid || this.form.pristine || this.form.disabled || !this.hasRecipients) return;

    this.AddSubscription(
      this.service.createLeaseAgreementMails(this._getFormData()).subscribe(
        () => { 
          this.clearRecipients();
          this.formSubmitted();
          this.messageService.showSuccess('SUCCESS_TEXT');
          this.navigation.navigateBack();
        },
        error => this.messageService.showError(error)
      )
    );

  }

  preview() {
    if (!this.hasRecipients) return;
    this.AddSubscription(this.service.previewTenatMails(this._getFormData()).subscribe(res => this._nativeWindow.openFile(res)));
  }

  send() {
    if (!this.hasRecipients) return;
    this.AddSubscription(
      this.service.sendToTenants(this._getFormData()).subscribe(
        () => {
          this.clearRecipients();
          this.formSubmitted();
          this.messageService.showSuccess('SUCCESS.LETTER_PROCESSING');
          this.navigation.navigateBack();
        },
        error => this.messageService.showError(error)
      )
    );
  }
}
